type Props = {
  title: string;
};

export function PlaceholderPage({ title }: Props) {
  return (
    <section className="page-placeholder">
      <div className="page-head">
        <div>
          <h1>{title}</h1>
        </div>
      </div>
    </section>
  );
}
